<template>
  <div :style="areaStyle">
    <div class="picture-article-container"
         @click="jumpUrl(specialEntryList[0])"
    >
      <div class="picture-box">
        <h2 class="picture-article-title" :style="titleStyle">{{ specialEntryList[0].titleName }}</h2>
        <div class="picture-article-content"
             :style="contentStyle"
        >
          {{ specialEntryList[0].titleDes }}
        </div>
      </div>
      <div :class="{'bg-opacity':
      !!pictureBg &&
      specialEntryList[0].titleName &&
      specialEntryList[0].titleDes}"
           v-if="!!pictureBg"
           :style="pictureStyle">
        <div v-if="!!pictureBg &&
      specialEntryList[0].titleName &&
      specialEntryList[0].titleDes" class="coverImage" :style="coverImg"></div>
        <img class="picture-article-img" v-if="pictureBg" :src="pictureBg" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import {commonClickFn} from './clickJs'

export default {
  name: "graphicOverlay",
  data() {
    const {tempData: {specialData, specialStyle, specialEntryList}, terminal} = this.data
    return {
      specialData,
      specialStyle,
      specialEntryList,
      terminal,
      pictureBg: specialEntryList[0].entryImg
    }
  },
  props: {
    data: {
      type: Object
    },
  },

  computed: {

    coverImg() {
      const {
        maskColor,
      } = this.specialStyle;
      return {
        backgroundColor: maskColor ? maskColor : 'none',
      }
    },

    areaStyle() {
      const {
        blockMargeTop,
        blockMargeBottom,
        blockBGClolor,
      } = this.specialStyle;
      return {
        marginTop: `${blockMargeTop ? blockMargeTop : 0}px`,
        marginBottom: `${blockMargeBottom ? blockMargeBottom : 0}px`,
        backgroundColor: blockBGClolor ? blockBGClolor : 'none',
      }
    },
    pictureStyle() {
      const {
        imgRadius,
        imgShadow,
        imgBorder,
        imgBackgroundColor = '',
      } = this.specialStyle;
      return {
        backgroundColor: imgBackgroundColor ? imgBackgroundColor : '',
        borderRadius: imgRadius ? '4px' : '',
        boxShadow: imgShadow ? '0px 0px 8px 0px rgba(0, 0, 0, 0.1)' : '',
        border: imgBorder ? `1px solid #D6DEEA` : 'none',
      }
    },


    titleStyle() {
      const {
        titleSize,
        titleColor,
        titleBold = false,
        titleAlign
      } = this.specialStyle;
      return {
        fontSize: `${titleSize ? titleSize : 16}px`,
        color: titleColor,
        fontWeight: `${titleBold ? 'bold' : ''}`,
        textAlign: titleAlign ? titleAlign : 'center',
      }
    },
    contentStyle() {
      const {
        descSize,
        descColor,
        descBold = false,
        descAlign
      } = this.specialStyle;
      return {
        fontSize: `${descSize ? descSize : 12}px`,
        color: descColor ? descColor : '',
        fontWeight: `${descBold ? 'bold' : ''}`,
        textAlign: descAlign ? descAlign : 'center',
      }
    },
  },
  methods: {
    //跳转
    jumpUrl(item) {
      commonClickFn(item, this.specialData, this, true)
    },

    // 数组处理
    getImageInfoList(articleDataList) {
      let idList = []
      articleDataList.map((item) => {
        idList.push(item.articleId)
      })
      this.$apis.cms.getImageList(idList).then(res => {
        // let imageInfoList = []
        let ImageInfoList = res.data
        articleDataList.map((item, index) => {
          // ImageInfoList[index] && (item.entryImg = ImageInfoList[index].thumbnail)
          ImageInfoList[index] && (item.id = ImageInfoList[index].id)
        })
      })
    }
  },
  mounted() {
    if (this.specialEntryList) {
      this.getImageInfoList(this.specialEntryList)
    }
  }


};
</script>
<style lang="less" scoped>
.picture-article-container {
  position: relative;
  //padding: 48px 24px 64px;
  box-sizing: border-box;
  .picture-article-title {
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    position: relative;
    height: 44px;
    font-size: 32px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 44px;
    z-index: 2;
    word-break: break-all;
  }

  .picture-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 6;
  }

  .coverImage {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 5;
  }

  .bg-opacity {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    //&:after{
    //  content: '';
    //  position: absolute;
    //  top: 0;
    //  left: 0;
    //  width: 100%;
    //  height: 100%;
    //  //background: rgba(0,0,0,0.6);
    //  z-index: 5;
    //}
  }

  .picture-article-img {
    //position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    box-sizing: border-box;
  }

  .picture-article-content {
    position: relative;
    margin-top: 24px;
    font-weight: 400;
    color: #fff;
    line-height: 40px;
    z-index: 2;
    word-break: break-all;
  }
}
</style>
